import React from "react";

import { GradientDefs } from "../../GradientDefs";

/**
 * @component StarIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 * @prop {string} [gradient] - Optional CSS linear-gradient string to apply a custom fill.
 * Format: "linear-gradient(<angle>deg, <color1>, <color2>, ...)"
 *
 * @example
 * return (
 * <StarIcon gradient="linear-gradient(135deg, #4da2ed, #f72222)" />
 * )
 *
 * @example
 * return (
 *   <StarIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const StarIcon = React.forwardRef(
  (
    {
      gradient,
      ...props
    }: React.SVGProps<SVGSVGElement> & {
      gradient?: string;
    },
    ref?: React.Ref<SVGSVGElement>
  ) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      data-testid="StarIcon"
      fill={
        gradient
          ? "url(#icon-gradient)"
          : props?.fill
          ? props.fill
          : "var(--color-theme-600)"
      }
      focusable={false}
      ref={ref}
      {...props}
    >
      <GradientDefs gradient={gradient} />
      <path
        fillRule="nonzero"
        d="m12.264 18.74-5.26 2.766a1 1 0 0 1-1.451-1.054l1.004-5.857-4.255-4.148a1 1 0 0 1 .554-1.706l5.881-.854 2.63-5.33a1 1 0 0 1 1.793 0l2.63 5.33 5.881.854a1 1 0 0 1 .554 1.706l-4.255 4.148 1.005 5.857a1 1 0 0 1-1.451 1.054z"
      />
    </svg>
  )
);
StarIcon.displayName = "StarIcon";
export default StarIcon;
